import moment from "moment";

export const EXPERIENCES = {
  CATEGORIES: [
    "culture",
    "gastronomy",
    // "well-being",
    "nature",
    "active-tourism",
  ],
  DURATIONS: ["2hours", "half-day", "full-day", "several-days"],
  PEOPLE_OPTIONS: [
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
    { label: "6", value: 6 },
    { label: "7", value: 7 },
    { label: "8", value: 8 },
    { label: "9", value: 9 },
    { label: "10", value: 10 },
  ],
  DEFAULT_DATE: moment(new Date()),
  LANGUAGES_OBJ: {
    pt: "Português",
    en: "Inglês",
    es: "Espanhol",
    fr: "Francês",
    it: "Italiano",
    de: "Alemão",
  },
  LANGUAGES_OPTS: [
    {
      label: "Português",
      value: "pt",
    },
    {
      label: "Espanhol",
      value: "es",
    },
    {
      label: "Francês",
      value: "fr",
    },
    {
      label: "Alemão",
      value: "de",
    },
    {
      label: "Inglês",
      value: "en",
    },
  ],
};

export const guide = {
  categories: [
    {
      label: "Cultura",
      value: "culture",
    },
    {
      label: "Gastronomia",
      value: "gastronomy",
    },
    {
      label: "Bem-estar",
      value: "well-being",
    },
    {
      label: "Natureza",
      value: "nature",
    },
    {
      label: "Turismo ativo",
      value: "active-tourism",
    },
  ],
  languages: [
    {
      label: "Português",
      value: "pt",
    },
    {
      label: "Espanhol",
      value: "es",
    },
    {
      label: "Francês",
      value: "fr",
    },
    {
      label: "Alemão",
      value: "de",
    },
    {
      label: "Inglês",
      value: "en",
    },
  ],
  durations: [
    { label: "1 hora", value: "1h" },
    { label: "2 horas", value: "2h" },
    { label: "3 horas", value: "3h" },
    { label: "4 horas", value: "4h" },
    { label: "5 horas", value: "5h" },
    { label: "6 horas", value: "6h" },
    { label: "7 horas", value: "7h" },
    { label: "8 horas", value: "8h" },
  ],
  durationDefault: "1h",
};
